import React from 'react';
import {NativeStackScreenProps} from '@react-navigation/native-stack';
import {useContextState as userContext} from '../../../../context/user';
import {StackParamList} from '../../../../navigators';
import {SuccessTemplate} from '../../../../components/templates/success';
import {PrimaryButton} from '../../../../components/buttons';
import {message} from '../../../../utils/messages';

type ScreenProps = NativeStackScreenProps<StackParamList, 'RemoveSuccess'>;

export const RemoveSuccessScreen = ({}: ScreenProps) => {
  const {signOff} = userContext();

  const handlePrimaryPress = async () => {
    signOff();
  };

  return (
    <SuccessTemplate
      title={message('remove-success-title')}
      summary={message('remove-success-summary')}>
      <PrimaryButton
        label={message('send-success-primary-button')}
        onPress={() => handlePrimaryPress()}
      />
    </SuccessTemplate>
  );
};
